import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons

// core components
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";


import PCAJavaScript from '../../assets/img/certificate/Rachit_Mehrotra_20210713_PCA - JavaScript Certification.jpg';

import PCAIT from '../../assets/img/certificate/Rachit_Mehrotra_20210127_Prudential_Asia.jpg';

import Python from '../../assets/img/certificate/UC-ce4d5c18-541e-46a2-b0e1-cec73888d553.jpg';

import Kafka from '../../assets/img/certificate/Kafka.jpg';

import DM from '../../assets/img/certificate/DM.jpg';

import Angular from '../../assets/img/certificate/Angular.jpg';

import styles from "assets/jss/material-kit-react/views/loginPage.js";

import image from "assets/img/Images/Halloffame2.jpg";

const useStyles = makeStyles(styles);

export default function HallOfFame(props) {
    const [cardAnimaton, setCardAnimation] = React.useState("cardHidden");
    setTimeout(function () {
        setCardAnimation("");
    }, 700);
    const classes = useStyles();
    const { ...rest } = props;
    return (
        <div>
            <Header
                absolute
                color="transparent"
                brand="Rachit Mehrotra.io"
                rightLinks={<HeaderLinks />}
                {...rest}
            />
            <div
                className={classes.pageHeader}
                style={{
                    backgroundImage: "url(" + image + ")",
                    backgroundSize: "cover",
                    backgroundPosition: "top center",
                }}
            >
                <div className={classes.container}>
                    <h3>My Certifications</h3>

                    <GridContainer justify="center">

                        <GridItem xs={12} sm={12} md={4}>
                            <Card className={classes[cardAnimaton]}>

                                <img src={PCAJavaScript} alt="Logo" width='350' height='300' style={{ borderRadius: '20px' }} />

                            </Card>
                        </GridItem>

                        <GridItem xs={12} sm={12} md={4}>
                            <Card className={classes[cardAnimaton]}>

                                <img src={PCAIT} alt="Logo" width='350' height='300' style={{ borderRadius: '20px' }} />

                            </Card>
                        </GridItem>

                        <GridItem xs={12} sm={12} md={4}>
                            <Card className={classes[cardAnimaton]}>

                                <img src={Python} alt="Logo" width='350' height='300' style={{ borderRadius: '20px' }} />

                            </Card>
                        </GridItem>

                        <GridItem xs={12} sm={12} md={4}>
                            <Card className={classes[cardAnimaton]}>

                                <img src={Kafka} alt="Logo" width='350' height='300' style={{ borderRadius: '20px' }} />

                            </Card>
                        </GridItem>


                        <GridItem xs={12} sm={12} md={4}>
                            <Card className={classes[cardAnimaton]}>

                                <img src={DM} alt="Logo" width='350' height='300' style={{ borderRadius: '20px' }} />

                            </Card>
                        </GridItem>

                        <GridItem xs={12} sm={12} md={4}>
                            <Card className={classes[cardAnimaton]}>

                                <img src={Angular} alt="Logo" width='350' height='300' style={{ borderRadius: '20px' }} />

                            </Card>
                        </GridItem>


                    </GridContainer>
                </div>
                <Footer whiteFont />
            </div>
        </div>
    );
}
